import { User, Shield, Mail } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const teamMembersSchema = defineSchema({
  id: 'team-members',
  title: 'filter.schema.teamMembers.title',
  subtitle: 'filter.schema.teamMembers.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'filter.field.memberName',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.memberName',
      description: 'filter.desc.memberName',
      example: 'name:Yanick',
    },
    role: {
      key: 'role',
      label: 'filter.field.role',
      type: 'enum',
      icon: Shield,
      allowMultiple: true,
      description: 'filter.desc.role',
      options: [
        { value: 'admin', label: 'team.role.admin' },
        { value: 'manage', label: 'team.role.manage' },
        { value: 'read', label: 'team.role.read' },
      ],
      example: 'role:manage',
    },
    email: {
      key: 'email',
      label: 'filter.field.email',
      type: 'text',
      icon: Mail,
      placeholder: 'filter.placeholder.email',
      description: 'filter.desc.email',
      example: 'email:gmail.com',
    },
  },
  examples: [
    { q: 'Yanick', desc: 'filter.example.findMemberYanick' },
    { q: 'role:admin', desc: 'filter.example.findTeamAdmins' },
    { q: 'role:manage', desc: 'filter.example.findTeamManage' },
  ],
});

